import { render, staticRenderFns } from "./SignedDocumentsList.vue?vue&type=template&id=e20b48e4"
import script from "./SignedDocumentsList.vue?vue&type=script&lang=js"
export * from "./SignedDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./SignedDocumentsList.vue?vue&type=style&index=0&id=e20b48e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports